import React from "react"
import ReactDOM from "react-dom"
import BookingHistory from "./booking-history"
export const hosts = document.body && document.body.dataset.hosts && JSON.parse(document.body.dataset.hosts)

export default class BookingHistoryModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.init()
    return self
  }
  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<BookingHistory lang={document.body && document.body.dataset.language} {...self.modelJson} />, self.elem)
  }
}
